export default __webpack_public_path__ + "static/NCD-Social-621085954036b8f823c4276678948555.jpg";